// extracted by mini-css-extract-plugin
module.exports = {"dropDownAction":"TableActionDropdown_dropDownAction_3Mjou"};